import { createTheme } from '@mui/material/styles';

import { getColorTokens } from './colorTokens';
import { ChipTheme, TextFieldTheme } from './componentStyles';
import { BrandCodes } from './types';

// To do: Refactor this into a hook file. Complete after merging all the dependent PRs

export const getTheme = (brandCode: BrandCodes) => {
  const colorTokens = getColorTokens(brandCode);

  const theme = createTheme({
    palette: {
      white: colorTokens.colorWhite,
      brand: {
        primary: colorTokens.colorBrandPrimary,
        dark: colorTokens.colorBrandDark,
        higlightLvl1: colorTokens.colorBrandHighlight,
        secondary: colorTokens.colorBrandSecondary
      },
      gradient: { brand: colorTokens.colorGradientBrand },
      interaction: {
        primary: colorTokens.colorInteractionPrimary,
        primaryFeedback: colorTokens.colorInteractionPrimaryFeedback,
        primaryHover: colorTokens.colorInteractionPrimaryHover,
        secondary: colorTokens.colorInteractionSecondary,
        secondaryHover: colorTokens.colorInteractionSecondaryHover
      },
      neutral: {
        border: colorTokens.colorNeutralBorder,
        divider: colorTokens.colorNeutralDivider,
        inactive: colorTokens.colorNeutralInactive,
        primary: colorTokens.colorNeutralPrimary,
        secondary: colorTokens.colorNeutralSecondary,
        surface: colorTokens.colorNeutralSurface
      },
      overlay: {
        dark4: colorTokens.colorDark4,
        dark64: colorTokens.colorDark64
      },
      tag: {
        popularHighlight: colorTokens.colorPopularHighlight,
        popularTagIcon: colorTokens.colorPopularTagIcon,
        popularTagText: colorTokens.colorPopularTagText
      },
      system: {
        error: colorTokens.colorError,
        errorHighlight: colorTokens.colorErrorHighlight,
        information: colorTokens.colorInformation,
        informationHighlight: colorTokens.colorInformationHighlight,
        success: colorTokens.colorSuccess,
        successHighlight: colorTokens.colorSuccessHighlight,
        warning: colorTokens.colorWarning,
        warningHighlight: colorTokens.colorWarningHighlight
      }
    },
    // values from https://bento.deliveryhero.net/3d2d84a09/p/5236ec-corner-radius
    cornerRadius: {
      xxxs: '2px',
      xxs: '4px',
      xs: '8px',
      sm: '12px',
      md: '16px',
      full: '50%'
    },
    // values from https://bento.deliveryhero.net/3d2d84a09/p/64cdff-spacing
    space: {
      xxxs: '2px',
      xxs: '4px',
      xs: '8px',
      sm: '16px',
      md: '24px',
      lg: '32px',
      xl: '48px',
      xxl: '80px'
    },
    typography: {
      htmlFontSize: 10,
      fontFamily: [
        'Open Sans',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"'
      ].join(','),
      body1: {
        fontWeight: '600',
        fontSize: '12px',
        lineHeight: '150%'
      },
      labelSm: {
        fontWeight: '700',
        fontSize: '12px',
        lineHeight: '150%'
      },
      labelSmSecondary: {
        fontWeight: '400',
        fontSize: '12px',
        lineHeight: '150%'
      },
      labelMd: {
        fontWeight: '600',
        fontSize: '14px',
        lineHeight: '150%'
      },
      labelLg: {
        fontWeight: '600',
        fontSize: '16px',
        lineHeight: '150%'
      },
      paragraphXs: {
        fontWeight: '600',
        fontSize: '12px',
        lineHeight: '150%'
      },
      paragraphXsSecondary: {
        fontWeight: '400',
        fontSize: '12px',
        lineHeight: '150%'
      },
      paragraphMd: {
        fontWeight: '400',
        fontSize: '16px',
        lineHeight: '150%'
      },
      paragraphSm: {
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '150%'
      },
      mini: {
        fontWeight: '700',
        fontSize: '10px',
        lineHeight: '160%'
      },
      titleXl: {
        fontWeight: '600',
        fontSize: '32px',
        lineHeight: '42px'
      },
      titleLg: {
        fontWeight: '700',
        fontSize: '24px',
        lineHeight: '32px'
      },
      titleSm: {
        fontWeight: '600',
        fontSize: '16px',
        lineHeight: '24px'
      },
      titleMd: {
        fontWeight: '700',
        fontSize: '18px',
        lineHeight: '28px'
      }
    },
    components: {
      MuiChip: ChipTheme,
      MuiTextField: TextFieldTheme
    }
  });

  return theme;
};
